import React, { useState } from "react";
import { StyledButton, StyledSpinnerWrapper } from "../styles/styledComponents";

import "../styles/snowbarrier-short.component.css";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import styled from "styled-components";
import { CircularProgress } from "@mui/material";
import ApiDataService from "../services/ApiDataService";
import ShortSnowbarrierResult from "../types/Snowbarrier-short-result";
import { faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const StyledLeftSpinnerWrapper = styled(StyledSpinnerWrapper)`
  justify-content: flex-start;
  padding-left: 0;
  margin-top: 10px;
  margin-bottom: 10px;
  margin: 0 auto;
`;

const ShortSnowbarrierComponent = () => {
  const { t } = useTranslation("trans");

  /* Fields values */
  const [roofType, setRoofType] = useState<string>("gableroof");
  const [snowload, setSnowload] = useState<string>("");
  const [roofElevation, setRoofElevation] = useState<string>("");
  const [roofLength, setRoofLength] = useState<string>("");
  const [distanceOuterConsole, setDistanceOuterConsole] = useState<string>("");
  const [distanceCCBrackets, setDistanceCCBrackets] = useState<string>("");
  const [maxOverHang, setMaxOverHang] = useState<string>("");

  const [isOpen, setIsOpen] = useState<boolean>(false);

  /* Results from calculate */
  const [result, setResult] = useState<ShortSnowbarrierResult>();

  const [error, setError] = useState(false);

  const onFieldChanged = (value: string, func: (value: string) => any) => {
    let val = value.replaceAll(",", ".");
    func(val);
  };

  /* Calculate max distance */
  const calculate = () => {
    if (snowload === "" || isNaN(+snowload)) {
      setError(true);
      return;
    }

    if (roofElevation === "" || isNaN(+roofElevation)) {
      setError(true);
      return;
    }
    if (roofLength === "" || isNaN(+roofLength)) {
      setError(true);
      return;
    }
    if (distanceOuterConsole === "" || isNaN(+distanceOuterConsole)) {
      setError(true);
      return;
    }
    if (distanceCCBrackets === "" || isNaN(+distanceCCBrackets)) {
      setError(true);
      return;
    }
    if (maxOverHang === "" || isNaN(+maxOverHang)) {
      setError(true);
      return;
    }
    setError(false);
    postCalculateSnowBarrier();
  };

  const { isLoading: isLoadingResult, mutate: postCalculateSnowBarrier } =
    useMutation<any, Error>(
      async () => {
        return await ApiDataService.calculateShortSnowbarrier(
          roofType,
          Number(snowload),
          Number(roofElevation),
          Number(roofLength),
          Number(distanceOuterConsole),
          Number(distanceCCBrackets),
          Number(0),
          Number(maxOverHang)
        );
      },
      {
        onSuccess: (res) => {
          setResult(res);
        },
        onError: (err: any) => {
          // console.log(err.response?.data || err);
        },
      }
    );

  const toggleClick = () => {
    setIsOpen(!isOpen);
  }
  const getAlert = (resultMessage: string) => {

      if (resultMessage === 'failed') {
          return (<div className="message-container errortext">
              <span>
                  {t('snowbarrier_short_page.alert_message')}
              </span>
          </div>)
      }
      else if (resultMessage === 'success') {
          return (<div className="message-container successtext">
              <span>
                  {t('snowbarrier_short_page.success_message')}
              </span>
          </div>)
      } else {
          return <></>;
      }


  }

  return (
    <div className="snowbarrier-short" style={ !isOpen ? {cursor: 'pointer', padding:'20px 0px 20px 50px'} : {cursor:'pointer', padding:'20px 50px'}}>
      <div onClick={toggleClick} style={{ float: "left", marginTop:"4px" }}>
            {!isOpen &&       <FontAwesomeIcon
            icon={faChevronDown}
            size="1x"

          />}
                {isOpen && <FontAwesomeIcon
            icon={faChevronUp}
            size="1x"

          />}
      </div>
      <h2 onClick={toggleClick} style={ !isOpen ? {marginBottom:'0px', marginLeft:'40px'} : {marginBottom:'40px', marginLeft:'40px'}}>{t("snowbarrier_short_page.title")}</h2>
      {isOpen && (
      <div>
      <p style={{ paddingBottom: "20px" }}>
        {t("snowbarrier_short_page.description")}
      </p>
      <div className="snowbarrier-short-inner">
        <div className="snowbarrier-short-inner-left">
          <div className="snowbarrier-short-inner-box">
            <h4>{t('snowbarrier_short_page.form_description')}</h4>

            <div className="inputfield">
              <label>
                {t("snowbarrier_short_page.roof_type")}
              </label>
              <select
                required
                id="rooftype"
                value={roofType}
                onChange={(e) => onFieldChanged(e.target.value, setRoofType)}>
                <option value="gableroof">{t("snowbarrier_short_page.dropdown_value_1")}</option>
                <option value="pentroof">{t("snowbarrier_short_page.dropdown_value_2")}</option>
              </select>

            </div>

            <div className="inputfield">
              <label>
                {t("snowbarrier_short_page.snowload")}
              </label>
              <input
                required
                id="snowLoad"
                value={snowload}
                onChange={(e) => onFieldChanged(e.target.value, setSnowload)}
              />
            </div>

            <div className="inputfield">
              <label>
                {t("snowbarrier_short_page.roof_elevation")}
              </label>
              <input
                required
                id="roofElevation"
                value={roofElevation}
                onChange={(e) =>
                  onFieldChanged(e.target.value, setRoofElevation)
                }
              />
            </div>

            <div className="inputfield">
              <label>
                {t("snowbarrier_short_page.roof_length")}
              </label>
              <input
                required
                id="roofLength"
                value={roofLength}
                onChange={(e) => onFieldChanged(e.target.value, setRoofLength)}
              />
            </div>
            <div className="inputfield">
              <label>
                {t("snowbarrier_short_page.distance_outer_console")}
              </label>
              <input
                required
                id="distanceOuterConsolse"
                value={distanceOuterConsole}
                onChange={(e) =>
                  onFieldChanged(e.target.value, setDistanceOuterConsole)
                }
              />
            </div>
            <div className="inputfield">
              <label>
                {t("snowbarrier_short_page.distance_cc_brackets")}
              </label>
              <input
                required
                id="distanceCCBrackets"
                value={distanceCCBrackets}
                onChange={(e) =>
                  onFieldChanged(e.target.value, setDistanceCCBrackets)
                }
              />
            </div>
            <div className="inputfield">
              <label>
                {t("snowbarrier_short_page.over_hang_from_snowbarrier_to_console_bracket")}
              </label>
              <input
                required
                id="maxOverHang"
                value={maxOverHang}
                onChange={(e) => onFieldChanged(e.target.value, setMaxOverHang)}
              />
            </div>

            {error ? (
              <div className="inputfield errortext">
                <span>{t("snowbarrier_short_page.error")}</span>
              </div>
            ) : (
              ""
            )}
            <StyledButton typeof="button" onClick={calculate}>
              {t("buttons.calculate")}
            </StyledButton>

            {isLoadingResult ? (
              <StyledLeftSpinnerWrapper>
                <CircularProgress color="inherit" />
                {t("calculating")}
              </StyledLeftSpinnerWrapper>
            ) : (
              <>
                {result ?
                  <>
        
                      <div className="resultField">
                        <label>
                          {t("snowbarrier_short_page.area")}
                        </label>
                        <p>{result.area} </p>
                        <label>{t("snowbarrier_short_page.loading_on_console")}</label>
                        <p>{result.loadingOnConsole} </p>
                      </div>
   
                    {getAlert(result.alertMessage)}
                    </> : (
                    ""
                  )}
              </>
            )}
          </div>
        </div>

        <div className="snowbarrier-short-inner-right">
          <div className="snowbarrier-short-inner-box">
            <p>{t("snowbarrier_short_page.instruction")}</p>
            <div className="inputfield">
              <img src="short_snowbarrier.jpg" width="450" />
            </div>
          </div>
        </div>
      </div>
      </div>
      )}
    </div>
  );
};

export default ShortSnowbarrierComponent;
